import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import StudentSidebar from "./StudentSidebar";
import StudentHeader from "./StudentHeader";
import { useSuspensionCheck } from "@/Teacherdashboard/useSuspensionCheck";
import { Loader2 } from "lucide-react";
import SuspensionWarning from "@/Teacherdashboard/SuspensionWarning";
import SchoolCalendar from "@/components/SchoolCalendar";

const StudentSchoolCalendar = () => {
  const { isSuspended, isLoading, schoolName: suspendedSchoolName, schoolID, hasValidClaims } = useSuspensionCheck();

  if (isLoading) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <StudentSidebar />
          <div className="flex flex-col flex-1 h-full">
            <StudentHeader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <div className="flex items-center justify-center h-[60vh]">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  if (isSuspended) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <StudentSidebar />
          <div className="flex flex-col flex-1 h-full">
            <StudentHeader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <SuspensionWarning schoolName={suspendedSchoolName} />
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <StudentSidebar />
        <div className="flex flex-col flex-1 h-full">
          <StudentHeader />
          <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
            <SchoolCalendar schoolID={hasValidClaims ? schoolID : null} />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default React.memo(StudentSchoolCalendar);
